"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var helpers_1 = require("../../helpers");
var Suggest_1 = require("../../Suggest");
var Dropdown_1 = require("../Dropdown");
var TagInputControl_1 = require("./TagInputControl");
var useControlState_1 = require("../helpers/useControlState");
var getStylesWithMaxWidth_1 = require("../../helpers/getStylesWithMaxWidth");
var AddIcon_1 = require("./icons/AddIcon");
var public_1 = require("../../common/public");
var helpers_2 = require("./helpers");
exports.TagInput = helpers_1.createUIElement('TagInput', function (_a, ref) {
    var className = _a.className, placeholder = _a.placeholder, _b = _a.value, tags = _b === void 0 ? [] : _b, disabled = _a.disabled, _c = _a.data, data = _c === void 0 ? [] : _c, error = _a.error, newTagError = _a.newTagError, _d = _a.canAdd, canAdd = _d === void 0 ? true : _d, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, _e = _a.size, size = _e === void 0 ? public_1.CONTROL_SIZE.m : _e, texts = _a.texts, _f = _a.maxNumberOfLines, maxNumberOfLines = _f === void 0 ? 4 : _f, _g = _a.hasSuggest, hasSuggest = _g === void 0 ? true : _g, onCreateNew = _a.onCreateNew, validateNewItem = _a.validateNewItem, onNewTagErrorChange = _a.onNewTagErrorChange, _h = _a.hasEnterKeyStopPropagation, hasEnterKeyStopPropagation = _h === void 0 ? true : _h, _j = _a.hasBlurEnter, hasBlurEnter = _j === void 0 ? false : _j, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "placeholder", "value", "disabled", "data", "error", "newTagError", "canAdd", "onChange", "onFocus", "onBlur", "size", "texts", "maxNumberOfLines", "hasSuggest", "onCreateNew", "validateNewItem", "onNewTagErrorChange", "hasEnterKeyStopPropagation", "hasBlurEnter", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var rootRef = react_1.useRef(null);
    var buttonRef = ref || rootRef;
    tags = Array.from(new Set(tags)) || [];
    var valueState = helpers_1.useStateValue(tags, [tags]);
    var _k = react_1.useState(''), searchTerm = _k[0], setSearchTerm = _k[1];
    var hasAddAction = searchTerm && canAdd && !(data === null || data === void 0 ? void 0 : data.includes(searchTerm));
    var _l = useControlState_1.useControlState({
        rootRef: buttonRef,
        onBlur: function () {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        },
        onFocus: onFocus
    }), active = _l.active, focused = _l.focused, activate = _l.activate, preventBlur = _l.preventBlur, input = _l.input;
    var validateNewTag = function (value) {
        var _a;
        var error = (_a = validateNewItem === null || validateNewItem === void 0 ? void 0 : validateNewItem(value)) !== null && _a !== void 0 ? _a : '';
        if (error) {
            onNewTagErrorChange === null || onNewTagErrorChange === void 0 ? void 0 : onNewTagErrorChange(error);
        }
        return !error;
    };
    function onSearchHandler(value) {
        if (newTagError) {
            onNewTagErrorChange === null || onNewTagErrorChange === void 0 ? void 0 : onNewTagErrorChange('');
        }
        setSearchTerm(value);
    }
    var getDefaultPlaceholder = function (hasSuggest) {
        if (hasSuggest) {
            return helpers_2.DEFAULT_TEXTS.placeholderWithSuggest;
        }
        return helpers_2.DEFAULT_TEXTS.placeholderWithoutSuggest;
    };
    var control = Dropdown_1.useDropdown({
        ref: buttonRef,
        offset: 1,
        renderControl: function (_a) {
            var actions = _a.actions, isActive = _a.isActive;
            return (react_1.default.createElement(TagInputControl_1.TagInputControl, __assign({}, rest, { hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, hasBlurEnter: hasBlurEnter, "data-selector-id": rest['data-selector-id'] || 'taginput', className: "vm-TagInput " + className, placeholder: placeholder || getDefaultPlaceholder(hasSuggest), focused: focused, active: active, disabled: disabled, value: valueState.getValue(), error: error || newTagError, inputError: newTagError, opened: isActive, canAdd: canAdd, hasSuggest: hasSuggest, data: data, onChange: onChange, size: size, maxNumberOfLines: maxNumberOfLines, searchTerm: searchTerm, onSearch: onSearchHandler, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onRequestOpen: function () {
                    actions.show();
                    activate();
                }, onRequestClose: function () {
                    actions.hide();
                    activate();
                }, validateNewTag: validateNewTag, onBlur: input.onBlur, onFocus: input.onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: buttonRef, style: style })));
        },
        renderPopover: function (_a) {
            var actions = _a.actions, popover = _a.popover;
            if (!hasSuggest) {
                return null;
            }
            var style = popover.style;
            return (react_1.default.createElement(Suggest_1.Suggest, { ref: popover.ref, renderEmptyMessage: Suggest_1.createEmptyMessageRenderer({
                    text: (texts === null || texts === void 0 ? void 0 : texts.empty) || 'No tags found'
                }), searchTerm: searchTerm, textGetter: function (item) { return item.tag; }, onSelect: function (item) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArrays(valueState.getValue(), [item.tag]));
                    setSearchTerm('');
                    actions.hide();
                }, filter: function (i) { var _a; return !((_a = valueState.getValue()) === null || _a === void 0 ? void 0 : _a.includes(i.tag)); }, data: data.map(function (tag) { return ({
                    tag: tag
                }); }), renderTrailerItem: hasAddAction
                    ? Suggest_1.createNewItemActionRenderer({
                        action: {
                            text: (texts === null || texts === void 0 ? void 0 : texts.createNew) || 'Create New',
                            icon: react_1.default.createElement(AddIcon_1.AddIcon, null),
                            onClick: function () {
                                if (!validateNewTag(searchTerm)) {
                                    return;
                                }
                                onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArrays(valueState.getValue(), [searchTerm]));
                                setSearchTerm('');
                                onCreateNew === null || onCreateNew === void 0 ? void 0 : onCreateNew(searchTerm);
                            }
                        }
                    })
                    : undefined, onMouseDown: preventBlur, style: getStylesWithMaxWidth_1.getStylesWithMaxWidth(style) }));
        },
        dropdownWidth: Dropdown_1.DROPDOWN_WIDTH.minControlWidthAndMaxXXL
    })[0];
    return control;
});
//# sourceMappingURL=TagInput.js.map